import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';

import { AtividadeMaterial } from '../models/atividade-material';

@Injectable({
  providedIn: 'root',
})
export class AtividadeMateriaisService {
  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore;
  }

  getAtividadeMateriais(idAtividade: number): Observable<AtividadeMaterial[]> {
    const url = this.environmentUrl + 'atividade/' + idAtividade + '/material';
    return this.httpClient.get<AtividadeMaterial[]>(url);
  }
}
